<!--
 * @Author: cn1994
 * @Date: 2024-10-24 09:55:14
 * @LastEditors: cn1994
 * @LastEditTime: 2024-10-30 16:03:51
 * @Description: file content
-->
<template>
  <el-dropdown :size="size" :trigger="trigger" @command="handleCommand">
    <el-button :type="linkType" size="small">
      {{ linkText }}<i v-if="showArrow" class="el-icon-arrow-down el-icon--right"></i>
    </el-button>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        v-for="(item, index) in options"
        :key="index"
        :command="item.command"
      >
        {{ item.label }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import mixin from './index.js'

export default {
  name: 'LsDropdown',
  componentName: 'LsDropdown',
  mixins: [mixin],
  directives: {},
  props: {
    size: {
      type: String,
      default: 'small',
      validator: (val) => ['mini', 'small', 'medium', 'large'].includes(val),
    },
    trigger: {
      type: String,
      default: 'click',
      validator: (val) => ['click', 'hover'].includes(val),
    },
    linkType: {
      type: String,
      default: 'primary',
      validator: (val) => ['primary', 'text'].includes(val),
    },
    linkText: {
      type: String,
      default: '更多菜单'
    },
    options: {
      type: Array,
      default: []
    },
    showArrow: { // 是否展示下拉icon
      type: Boolean,
      default: true,
    }
  },
  data () {
    return {
      
    }
  },
  methods: {
    handleCommand(command) {
      this.$emit('command', command)
    }
  }
}

</script>

<style lang="less" scoped>
@import url('./index.less');
</style>